import { render, staticRenderFns } from "./AvatarsStore.vue?vue&type=template&id=2b25bc6d&"
import script from "./AvatarsStore.vue?vue&type=script&lang=js&"
export * from "./AvatarsStore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports